<script setup>
import AlertList from '@/components/shared/AlertList.vue'
import Footer from '@/layouts/partials/Footer.vue'
import Navbar from '@/layouts/partials/Navbar.vue'
</script>

<template>
    <div class="flex min-h-screen flex-col justify-between">
        <Navbar />

        <main
            id="main-content"
            tabindex="-1"
        >
            <slot />
        </main>

        <Footer />
        <AlertList />
        <!-- <FlashToast /> -->
    </div>
</template>
